import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel, Select, MenuItem, Autocomplete } from "@mui/material";
import { useEffect, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useCompanyStore } from "../../../hooks/useCompanyStore";
import { useListOfProductStore } from "../../../hooks/useListOfProductStore";
import { useBranchOfficeStore } from "../../../hooks/useBranchOfficeStore";
import { useUbigeoStore } from "../../../hooks/useUbigeoStore";

type Values = {
    id: number,
    code: string,
    name: string,
    phone: string,
    address: string,
    // assignmenttype: string,
    // idproductlist: number,
    idofficetype: number,
    idcountry: number,
    iddepartment: number,
    idprovince: number,
    iddistrict: number,
    idcompany: number,
    status: string,
}

const listProductsData = [
    { id: 1, name: 'Lista demo'},
]

const assignments = [
    { id: '1', name: 'Sucursal'},
    { id: '2', name: 'Usuario'},
]

export const BranchOfficeModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, branchofficeSelected, listBranchoffices, clearState } = props;

    const { action, createBranchOffice, editBranchOffice, getTypesBranches } = useBranchOfficeStore();
    const { getCountries, getDepartments, getProvinces, getDistricts } = useUbigeoStore();
    const { getListOfProducts } = useListOfProductStore();
    const { getCompanies } = useCompanyStore();

    const [loading, setLoading] = useState(false);
    const [loadingdata, setLoadingdata] = useState(false);

    const [companies, setCompanies] = useState<any>([]);
    const [companyselected, setCompanySelected] = useState<any>('');
    const [listProducts, setListProducts] = useState<any>([]);
    const [listProductselected, setlistProductSelected] = useState<any>('');
    const [listTypeBranches, setListTypeBranches] = useState<any>([]);
    const [typeBranchselected, settypeBranchSelected] = useState<any>('');

    const [countries, setCountries] = useState<any>([]);
    const [countryselected, setCountrySelected] = useState<any>('');
    const [departments, setDepartments] = useState<any>([]);
    const [departmentselected, setDepartmentSelected] = useState<any>('');
    const [provinces, setProvinces] = useState<any>([]);
    const [provinceselected, setProvinceSelected] = useState<any>('');
    const [districts, setDistricts] = useState<any>([]);
    const [districtselected, setDistrictSelected] = useState<any>('');

    const [data, setData] = useState<Values>({
        id: branchofficeSelected ? branchofficeSelected.id :'',
        code: branchofficeSelected ? branchofficeSelected.code :'',
        name: branchofficeSelected ? branchofficeSelected.name :'',
        phone: branchofficeSelected ? branchofficeSelected.phone :'',
        address: branchofficeSelected ? branchofficeSelected.address :'',
        // assignmenttype: branchofficeSelected ? branchofficeSelected.assignmenttype :'',
        // idproductlist: branchofficeSelected ? branchofficeSelected.idproductlist :'',
        idofficetype: branchofficeSelected ? branchofficeSelected.idofficetype :'',
        idcountry: branchofficeSelected ? branchofficeSelected.idcountry :'',
        iddepartment: branchofficeSelected ? branchofficeSelected.iddepartment :'',
        idprovince: branchofficeSelected ? branchofficeSelected.idprovince :'',
        iddistrict: branchofficeSelected ? branchofficeSelected.iddistrict :'',
        idcompany: branchofficeSelected ? branchofficeSelected.idcompany :'',
        status: branchofficeSelected ? branchofficeSelected.status :'',
    });

    useEffect(() => {
        getcompaniesApi()
        getTypesBranchesApi()
        getCountriesApi()
    },[])

    useEffect(() => {
        if(branchofficeSelected.assignmenttype == '1') getListOfProductsApi();
    },[branchofficeSelected])

    useEffect(() => {
        if(branchofficeSelected && listProducts){
            setCustomListProducts(branchofficeSelected.idproductlist, listProducts)
        }
    },[branchofficeSelected, listProducts])

    useEffect(() => {
        if(branchofficeSelected && countries){
            setCustomCountry(branchofficeSelected.idcountry, countries)
            getDepartmentsApi(branchofficeSelected.idcountry)
        }
    },[branchofficeSelected, countries])

    useEffect(() => {
        if(branchofficeSelected && departments){
            setCustomDepartment(branchofficeSelected.iddepartment, departments)
            getProvincesApi(branchofficeSelected.iddepartment)
        }
    },[branchofficeSelected, departments])

    useEffect(() => {
        if(branchofficeSelected && provinces){
            setCustomProvince(branchofficeSelected.idprovince, provinces)
            getDistrictsApi(branchofficeSelected.idprovince)
        }
    },[branchofficeSelected, provinces])

    useEffect(() => {
        if(branchofficeSelected && districts){
            setCustomDistrict(branchofficeSelected.iddistrict, districts)
        }
    },[branchofficeSelected, districts])

    useEffect(() => {
        if(branchofficeSelected && listTypeBranches){
            setCustomTypeBranch(branchofficeSelected.idofficetype, listTypeBranches)
        }
    },[branchofficeSelected, listTypeBranches])

    useEffect(() => {
        if(branchofficeSelected && companies){
            setCustomCompany(branchofficeSelected.idcompany, companies)
        }
    },[branchofficeSelected, companies])

    const getListOfProductsApi = async() => {
        try {
            setLoadingdata(true);
            // const response = await getListOfProducts();
            const response = listProductsData;
            if(!response){
                setListProducts([]);
                setLoadingdata(false);
                return false;
            }else{
                setListProducts(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const getTypesBranchesApi = async() => {
        try {
            setLoadingdata(true);
            const response = await getTypesBranches();
            if(!response){
                setListTypeBranches([]);
                setLoadingdata(false);
                return false;
            }else{
                setListTypeBranches(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const getcompaniesApi = async() => {
        try {
            setLoadingdata(true);
            const response = await getCompanies();
            if(!response){
                setCompanies([]);
                setLoadingdata(false);
                return false;
            }else{
                setCompanies(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const getCountriesApi = async() => {
        try {
            setLoadingdata(true);
            const response = await getCountries();
            if(!response){
                setCountries([]);
                setLoadingdata(false);
                return false;
            }else{
                setCountries(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getDepartmentsApi = async(idcountry='') => {
        try {
            setLoadingdata(true);
            const response = await getDepartments('', idcountry);
            if(!response){
                setDepartments([]);
                setLoadingdata(false);
                return false;
            }else{
                setDepartments(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getProvincesApi = async(iddeparment='') => {
        try {
            setLoadingdata(true);
            const response = await getProvinces('', iddeparment);
            if(!response){
                setProvinces([]);
                setLoadingdata(false);
                return false;
            }else{
                setProvinces(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getDistrictsApi = async(idprovince='') => {
        try {
            setLoadingdata(true);
            const response = await getDistricts('', idprovince);
            if(!response){
                setDistricts([]);
                setLoadingdata(false);
                return false;
            }else{
                setDistricts(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const setCustomListProducts = (idlist, listProducts) => {
        const data = listProducts.find(list => list.id == idlist);
        return setlistProductSelected(data);
    }
    const setCustomCompany = (idcompany, companies) => {
        const data = companies.find(company => company.id == idcompany);
        return setCompanySelected(data);
    }
    const setCustomTypeBranch = (idtype, listTypeBranches) => {
        const data = listTypeBranches.find(type => type.id == idtype);
        return settypeBranchSelected(data);
    }
    const setCustomCountry = (idcountry, countries) => {
        const data = countries.find(country => country.id == idcountry);
        return setCountrySelected(data);
    }
    const setCustomDepartment = (iddepartment, departments) => {
        const data = departments.find(department => department.id == iddepartment);
        return setDepartmentSelected(data);
    }
    const setCustomProvince = (idprovince, provinces) => {
        const data = provinces.find(province => province.id == idprovince);
        return setProvinceSelected(data);
    }
    const setCustomDistrict = (iddistrict, districts) => {
        const data = districts.find(district => district.id == iddistrict);
        return setDistrictSelected(data);
    }

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.code) errors.code = "el campo es requerido";
        if(!values.name) errors.name = "el campo es requerido";
        // if(!values.assignmenttype) errors.assignmenttype = "el campo es requerido";
        // if(values.assignmenttype == '1' && !values.idproductlist) errors.idproductlist = "el campo es requerido";
        if(!values.idcountry) errors.idcountry = "el campo es requerido";
        if(!values.iddepartment) errors.iddepartment = "el campo es requerido";
        if(!values.idprovince) errors.idprovince = "el campo es requerido";
        if(!values.iddistrict) errors.iddistrict = "el campo es requerido";
        if(!values.phone) errors.phone = "el campo es requerido";
        if(!values.address) errors.address = "el campo es requerido";
        if(!values.idofficetype) errors.idofficetype = "el campo es requerido";
        if(!values.idcompany) errors.idcompany = "el campo es requerido";
        return errors;
    }

    const onSubmit = async(values)  => {
        setLoading(true);

        if(branchofficeSelected){
            const response:any = await editBranchOffice(branchofficeSelected.id, values);
            if(response){
                listBranchoffices && listBranchoffices();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }else{
            const response:any = await createBranchOffice(values);
            if(response){
                listBranchoffices && listBranchoffices();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' }}}>
            <ModalHeader
                text={
                    action == 'edit' ? 'Editar sucursal' : (action == 'add' ? 'Nueva sucursal' : 'Detalle de la sucursal')
                }
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'20px'}}>
                                    <Grid item container xs={12} spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Código:</FormLabel>
                                            <TextField
                                                id="code"
                                                type="text" 
                                                name="code"
                                                fullWidth
                                                size="small"
                                                value={values.code}
                                                onChange={handleChange}
                                                error={errors.code && touched.code ? true : false}
                                                helperText={errors.code && touched.code ? errors.code : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Nombre completo:</FormLabel>
                                            <TextField
                                                id="name"
                                                type="text" 
                                                name="name"
                                                fullWidth
                                                size="small"
                                                value={values.name}
                                                onChange={handleChange}
                                                error={errors.name && touched.name ? true : false}
                                                helperText={errors.name && touched.name ? errors.name : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        {/* <Grid item xs={12} md={6}>
                                            <FormLabel>Tipo de asignación:</FormLabel>
                                            <Select
                                                id="assignmenttype"
                                                value={values.assignmenttype}
                                                size="small"
                                                onChange={(event) => { 
                                                    setFieldValue("assignmenttype", event.target.value);
                                                    if(event.target.value == '1') getListOfProductsApi();
                                                    if(event.target.value == '2') {setFieldValue("idproductlist", ""); setlistProductSelected("")}
                                                }}
                                                error={ errors.assignmenttype && touched.assignmenttype ? true : false }
                                                fullWidth
                                                inputProps={{ readOnly: action == 'detail' }}
                                            >
                                                {
                                                    assignments.map((assignment, i) => {
                                                        return <MenuItem key={i} value={assignment.id}>{assignment.name}</MenuItem>;
                                                    })
                                                }
                                            </Select>
                                        </Grid> */}
                                        {/* <Grid item xs={12} md={6}>
                                            <FormLabel>Lista de precios:</FormLabel>
                                            <Autocomplete
                                                id="idproductlist"
                                                size="small"
                                                value={!!listProductselected ? listProductselected : null}
                                                options={listProducts || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small"
                                                        error={errors.idproductlist && touched.idproductlist ? true : false}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setlistProductSelected(newValue)
                                                    setFieldValue('idproductlist', newValue ? newValue.id : "");
                                                }}
                                                disabled={values.assignmenttype == '2' || action == 'detail'}
                                            />
                                        </Grid> */}
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>País:</FormLabel>
                                            <Autocomplete
                                                id="idcountry"
                                                size="small"
                                                value={!!countryselected ? countryselected : null}
                                                options={countries || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small"
                                                        error={errors.idcountry && touched.idcountry ? true : false}
                                                        helperText={errors.idcountry && touched.idcountry ? errors.idcountry : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setCountrySelected(newValue)
                                                    setFieldValue('idcountry', newValue ? newValue.id : "");
                                                    if(newValue) getDepartmentsApi(newValue.id)

                                                    setDepartmentSelected("");
                                                    setProvinceSelected("");
                                                    setDistrictSelected("");
                                                }}
                                                readOnly={action == 'detail'}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Región:</FormLabel>
                                            <Autocomplete
                                                id="iddepartment"
                                                size="small"
                                                value={!!departmentselected ? departmentselected : null}
                                                options={departments || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small"
                                                        error={errors.iddepartment && touched.iddepartment ? true : false}
                                                        helperText={errors.iddepartment && touched.iddepartment ? errors.iddepartment : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setDepartmentSelected(newValue)
                                                    setFieldValue('iddepartment', newValue ? newValue.id : "");
                                                    if(newValue) getProvincesApi(newValue.id)

                                                    setProvinceSelected("");
                                                    setDistrictSelected("");
                                                }}
                                                readOnly={action == 'detail'}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Provincia:</FormLabel>
                                            <Autocomplete
                                                id="idprovince"
                                                size="small"
                                                value={!!provinceselected ? provinceselected : null}
                                                options={provinces || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small"
                                                        error={errors.idprovince && touched.idprovince ? true : false}
                                                        helperText={errors.idprovince && touched.idprovince ? errors.idprovince : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setProvinceSelected(newValue)
                                                    setFieldValue('idprovince', newValue ? newValue.id : "");
                                                    if(newValue) getDistrictsApi(newValue.id)

                                                    setDistrictSelected("");
                                                }}
                                                readOnly={action == 'detail'}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Comuna:</FormLabel>
                                            <Autocomplete
                                                id="iddistrict"
                                                size="small"
                                                value={!!districtselected ? districtselected : null}
                                                options={districts || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small"
                                                        error={errors.iddistrict && touched.iddistrict ? true : false}
                                                        helperText={errors.iddistrict && touched.iddistrict ? errors.iddistrict : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setDistrictSelected(newValue)
                                                    setFieldValue('iddistrict', newValue ? newValue.id : "");
                                                }}
                                                readOnly={action == 'detail'}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Teléfono:</FormLabel>
                                            <TextField
                                                id="phone"
                                                type="text" 
                                                name="phone"
                                                fullWidth
                                                size="small"
                                                value={values.phone}
                                                onChange={handleChange}
                                                error={errors.phone && touched.phone ? true : false}
                                                helperText={errors.phone && touched.phone ? errors.phone : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Dirección:</FormLabel>
                                            <TextField
                                                id="address"
                                                type="text" 
                                                name="address"
                                                fullWidth
                                                size="small"
                                                value={values.address}
                                                onChange={handleChange}
                                                error={errors.address && touched.address ? true : false}
                                                helperText={errors.address && touched.address ? errors.address : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Tipo de sucursal:</FormLabel>
                                            <Autocomplete
                                                id="idofficetype"
                                                size="small"
                                                value={!!typeBranchselected ? typeBranchselected : null}
                                                options={listTypeBranches || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small" 
                                                        error={errors.idofficetype && touched.idofficetype ? true : false}
                                                        helperText={errors.idofficetype && touched.idofficetype ? errors.idofficetype : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    settypeBranchSelected(newValue)
                                                    setFieldValue('idofficetype', newValue ? newValue.id : "");
                                                }}
                                                readOnly={action == 'detail'}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Compañia:</FormLabel>
                                            <Autocomplete
                                                id="idcompany"
                                                size="small"
                                                value={!!companyselected ? companyselected : null}
                                                options={companies || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.business_name || ''}
                                                isOptionEqualToValue={(option,value)=> option.business_name === value?.business_name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small"
                                                        error={errors.idcompany && touched.idcompany ? true : false}
                                                        helperText={errors.idcompany && touched.idcompany ? errors.idcompany : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setCompanySelected(newValue)
                                                    setFieldValue('idcompany', newValue ? newValue.id : "");
                                                }}
                                                readOnly={action == 'detail'}
                                            />
                                        </Grid>
                                        
                                    </Grid>
                                </Grid>
                                <Divider />
                                {
                                    action != 'detail' && (
                                        <ModalFooter 
                                            buttonType="submit"
                                            confirmText={'Guardar'}
                                            onConfirm={handleSubmit}
                                            cancelText={"Cancelar"}
                                            onCancel={closeModal}
                                            loadingConfirmText={loading}
                                            clearState={clearState}
                                        />
                                    )   
                                }
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
    )
}